// import React from 'react'

// const ViewMappedsupcharges = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default ViewMappedsupcharges





import { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  IconButton,
  TextField,
  Box,
  Breadcrumbs,
  Autocomplete, InputAdornment,
  Link, Tooltip,
} from "@mui/material";

import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewDataGridGrn from "../../components/grid/ViewDataGridGrn";
import { mappedchargeData  } from "../../components/grid/GridDataGrn";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import { externalgetApi } from "../../services/externalApis";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { SUPPLIER_API_02, SUPPLIER_API_04, SUPPLIER_API_10 } from "../../api/ApiModel";

import { useLocation } from "react-router-dom";


function ViewMappedsupcharges() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const [status, setStatus] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState({});
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // State for search input
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const { selectedItem, actionText,suprefcode,supname } = location.state || {};
  const SYS_USER = useSelector((state) => state.user) || {};
  const { LOCCODE, STAFFMAPLOCODE, COMPCODE } = SYS_USER.USER_PARAM || {};

  useEffect(() => {
    setPageData({
      title: "Supplier Products",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  
const handleItemClick = (id, actionText) => {
  if (actionText === "Edit") {
    const selectedItem = data.find((item) => item.supchargecode === id.supchargecode);
    if (selectedItem) {
      navigate(`/setupsupcharges`, { state: { selectedItem, actionText,suprefcode,supname } });
    }
  } 
};

  const goBackToView = () => {
    navigate("/mapsuppliercharges");
  };
  
  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (supchargecode) => handleItemClick(supchargecode, "Edit"),
    },
   
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SUPPLIER_API_10, "get", {
          COMPCODE,
          LOCCODE:STAFFMAPLOCODE,
         suprefcode:selectedItem?.suprefcode || 0,
          STS: CON_STATUS_ACTIVE,
        });

        setData(result);
        setFilteredRows(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [status]);

  // Handle search input change
  const handleSearchChange = (event, value) => {
    setSearchQuery(value); // Update search query state

    // Filter rows based on search query
    const filtered = data?.filter((row) =>
      row.supchargetype.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredRows(filtered || []);
  };

const addToView = () => {
  navigate("/setupsupcharges", {
    state: {
      selectedItem,
      actionText: "Map Product",
      suprefcode,
      supname
    }
  });
};

  return (
    <>
          <Box sx={styles.box_breadcrumb}>
              <Tooltip title="Back to All Items" arrow sx={styles.breadcrumb_tooltip}>
                <IconButton
                  aria-label="back"
                  sx={styles.btn_breadcrumb_back}
                  onClick={goBackToView}
                >
                  <ArrowBackIcon sx={styles.btn_breadcrumb_back_icon} />
                </IconButton>
              </Tooltip>
              <Typography sx={styles.breadcrumb_divider}>|</Typography>
        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>

          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
          Mapped Charges
          </Link>
        </Breadcrumbs>
      </Box>

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {mappedchargeData.name}
              </Typography>
               <Typography sx={{ color: "text.secondary", fontSize: 12 }}>
                 {supname}
                </Typography>
            </Grid>

        

            <Grid
              item
              size={{ xs: 12, sm: 4, md: 6, lg: 6, xl: 6 }}
              sx={styles.appbar_grid_search}
            >
              <Autocomplete
                freeSolo
                id="sample-search"
                fullWidth
                disableClearable
                value={searchQuery}
                onInputChange={handleSearchChange} // Handle search input change
                sx={styles.ipt_appbar_search_auto}
                options={data?.map((row) => row.supchargetype) || []} // Provide options for autocomplete
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search by..."
                    size="small"
                    sx={styles.ipt_appbar_search}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton sx={styles.btn_appbar_search_icon}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />

              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                size="small"
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={addToView}
              >
               Map Charges
              </Button>
            </Grid>
          </Grid>
        </AppBar>

        <Box sx={styles.view_page_container}>
          <ViewDataGridGrn
            columns={mappedchargeData.columns}
            rows={filteredRows.map((row) => ({
              ...row,
              id: row.supchargecode || Math.random(),
            }))}
            getRowId={(row) => row.id} // Use the id property for unique identification
            menuItems={menuItems}
            isLoading={isLoading}
            tabletitle={mappedchargeData.name}
            gridid="supchargecode"
            sx={styles.view_data_grid_page}
          />
        </Box>
      </Box>
    </>
  );
}
export default ViewMappedsupcharges;
